import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Building2, Loader2 } from "lucide-react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

function errText(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function SchoolLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${BASE}/school/login`, { email, password });
      localStorage.setItem("cc_school_token", data.token);
      localStorage.setItem("cc_school", JSON.stringify(data.school));
      nav("/school/dashboard");
    } catch (e2) {
      setErr(errText(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-[#16244F] outline-none focus:ring-2 focus:ring-[#F58220]";
  const label = "block text-sm font-semibold text-[#16244F] mb-1.5";

  return (
    <div className="min-h-screen bg-[#f7f8fb]">
      <Header />
      <main className="max-w-[460px] mx-auto px-5 py-16">
        <div className="bg-white rounded-2xl cc-shadow-card p-7 lg:p-9">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-[#16244F] grid place-items-center text-white">
              <Building2 size={22} />
            </div>
            <div>
              <h1 className="font-head text-2xl font-bold text-[#16244F]">School / College Login</h1>
              <p className="text-sm text-[#8a90a0]">Access your students' reports.</p>
            </div>
          </div>

          {err && <div className="mb-4 text-sm text-red-600 bg-red-50 rounded-lg px-4 py-3" data-testid="school-login-error">{err}</div>}

          <form onSubmit={submit} className="space-y-4" data-testid="school-login-form">
            <div>
              <label className={label}>Official Email ID</label>
              <input type="email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
            </div>
            <div>
              <label className={label}>Password</label>
              <input type="password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="school-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold text-sm px-5 py-3 rounded-lg transition-colors disabled:opacity-60"
            >
              {loading && <Loader2 size={16} className="animate-spin" />} Login
            </button>
          </form>

          <p className="text-sm text-[#8a90a0] mt-5 text-center">
            New institution? <Link to="/school/register" className="font-semibold text-[#F58220]" data-testid="to-school-register">Register here</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
